import { HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ModalRegisterComponent } from '../home/modal-register/modal-register.component';
import { AgenciasService } from '../_services/agencias.service';
import { ModalMsgComponent } from './modal-msg/modal-msg.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  ruta: string;
  id :string;
  menu: boolean = true;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private agenciasService:AgenciasService,
  ) {

   }

  ngOnInit(): void {
    this.ruta = ((this.router.url.split('#')[0]).split('/')[2]);
    this.id = ((this.router.url.split('#')[0]).split('/')[3]);
    if(this.ruta === 'tours-register' || this.ruta === 'tour-itinerario'
      || this.ruta === 'tour-excursiones' || this.ruta === 'tours-update') {
      this.menu = false;
    } else {
      this.menu = true;
    }
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.ruta = ((e.url.split('#')[0]).split('/')[2]);
        this.id = ((e.url.split('#')[0]).split('/')[3]);
        if(this.ruta === 'tours-register' || this.ruta === 'tour-itinerario'
          || this.ruta === 'tour-excursiones' || this.ruta === 'tours-update') {
          this.menu = false;
        }  else {
          this.menu = true;
        }
      }
    });
  }


  openRegister() {
    const modalRef = this.modalService.open(ModalRegisterComponent, {
      centered: true,
      backdrop:'static'
    });
    modalRef.componentInstance.padre = 'agencia';
  }

  aprobar(){
    this.agenciasService.aprobarAgencia(this.id).subscribe(data => {
      if(data instanceof HttpResponse) {
        var response = data.body;
        //Levantar un model
        const modalRef = this.modalService.open(ModalMsgComponent, {
          centered: true,
          backdrop:'static',
        });
        modalRef.componentInstance.padre = this.ruta;
        modalRef.componentInstance.label = 'Volver';
        if(response.msg === "SEND_MAIL_SUCCESS" || response.msg === "ERROR_SEND_MAIL") {
          modalRef.componentInstance.titulo = 'Agencia aprobada';
          modalRef.componentInstance.check = 1;
        } else {
          modalRef.componentInstance.titulo = 'Ha ocurrido un error';
          modalRef.componentInstance.check = 0;
        }
      }
    });
  }

  eliminar(){
    this.agenciasService.rechazarAgencia(this.id).subscribe(data => {
      if(data instanceof HttpResponse) {
        var response = data.body;
        //Levantar un model
        const modalRef = this.modalService.open(ModalMsgComponent, {
          centered: true,
          backdrop:'static',
        });
        modalRef.componentInstance.label = 'Volver';
        modalRef.componentInstance.padre = this.ruta;
        if(response.msg === "SEND_MAIL_SUCCESS" || response.msg === "ERROR_SEND_MAIL") {
          modalRef.componentInstance.titulo = 'Agencia eliminada';
          modalRef.componentInstance.check = 1;
        } else {
          modalRef.componentInstance.titulo = 'Ha ocurrido un error';
          modalRef.componentInstance.check = 0;
        }
      }
    });
  }

}
